<template lang="pug">
    .examples-viewer
        .examples-viewer__examples
            .example(v-for="(example, index) in parsedExamplesArray")
                .example__container(:style="exampleStyle(index)")
                    .example__title
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }} {{ index + 1 }}
                    .example__actions(:class="{'example__actions_beautiful-hyphenations': !exampleHasBigNumbers(index)}")
                        template(v-for="(number, index) in example.length")
                            span.example__element {{ getExampleElement(example, index) + ' ' }}
                            wbr(v-if="allowLineBreak(example, index)")
                    .example__answer
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}: {{ rightAnswersArray[index] }}
        .examples-viewer__button
            cs-button(
                color="blue"
                @click="$router.push({name: 'dashboard'})"
            )
                | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    const OPERATIONS = ['+', '-', '×', '÷'];

    export default {
        props: {
            examplesArray: Array,
            rightAnswersArray: Array,
            fractions: {
                type: Boolean,
                default: false,
            },
            fractionalPart: Number,
            numbers: Boolean,
        },
        data() {
            return {
                parsedExamplesArray: [],
                colors: [
                    'hsl(121, 58%, 58%)',
                    'hsl(212, 100%, 56%)',
                    'hsl(15, 100%, 64%)',
                    'hsl(38, 100%, 56%)',
                    'hsl(331, 100%, 68%)',
                    'hsl(158, 62%, 54%)',
                    'hsl(284, 59%, 64%)',
                    'hsl(195, 86%, 64%)',
                ],
            };
        },
        mounted() {
            this.stringExamplesToArray();
            this.focusTimeout = setTimeout(() => {
                this.$refs.input?.$el.focus();
            }, 200);
        },
        methods: {
            getLeftNumber(example) {
                return this.fractions && this.fractions.left && !(this.numbers && example.operation === '*')
                    ? Math.abs(example.left).toFixed(this.fractionalPart.left)
                    : Math.abs(example.left);
            },
            getRightNumber(example) {
                return this.fractions && this.fractions.right && !(this.numbers && example.operation === '/')
                    ? Math.abs(example.right).toFixed(this.fractionalPart.right)
                    : Math.abs(example.right);
            },
            exampleStyle(index) {
                return { color: this.colors[index % this.colors.length] };
            },
            stringExamplesToArray() {
                this.parsedExamplesArray = this.examplesArray.map(example => this.stringExampleToArray(example));
            },
            getExampleElement(example, index) {
                if (example[index] === '*') {
                    return '×';
                }
                if (example[index] === '/') {
                    return '÷';
                }
                return example[index];
            },
            stringExampleToArray(example) {
                let splittedExample = example.split('');
                let item = splittedExample[0];
                let parsedExample = [];
                for (let i = 0; i < splittedExample.length - 1; i++) {
                    if (this.isNumericOrDot(item) && this.isNumericOrDot(splittedExample[i + 1])) {
                        item += splittedExample[i + 1];
                    } else {
                        parsedExample.push(item);
                        item = splittedExample[i + 1];
                    }
                }
                parsedExample.push(item);
                return parsedExample;
            },
            allowLineBreak(example, index) {
                return OPERATIONS.includes(this.getExampleElement(example, index));
            },
            isNumericOrDot(n) {
                return (!isNaN(parseFloat(n)) && isFinite(n)) || n === '.';
            },
            exampleHasBigNumbers(exampleIndex) {
                const MIN_LENGTH_OF_BIG_NUMBER = 15;
                return [...this.parsedExamplesArray[exampleIndex], this.rightAnswersArray[exampleIndex]].find(
                    element => element?.length >= MIN_LENGTH_OF_BIG_NUMBER
                );
            },
        },
    };
</script>

<style lang="scss" scoped>
    .examples-viewer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .examples-viewer__examples {
        display: flex;
        margin: -10px -10px 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-size: $font-size-24;
    }
    .example {
        padding: 10px;
    }
    .example__actions {
        white-space: nowrap;
    }
    .example__actions_beautiful-hyphenations {
        white-space: nowrap;
    }
    .example__action:nth-child(2n) {
        filter: hue-rotate(10deg) saturate(50%);
    }
    .example__container {
        background-color: $x-color-white;
        padding: 10px;
        border: 1px solid;
        border-radius: $border-radius-10;
    }
    .example__title,
    .example__answer {
        @include stack-space($space-x-small);
    }
    .example__answer {
        word-break: break-all;
    }
    .examples-viewer__button {
        margin-top: 20px;
    }
</style>
